import {Translate} from "@components/Theme/Translate/Translate"
import React from "react"

type BadgeProps = {
	label: string
	color?: string
}

const Badge: React.FC<BadgeProps> = ({label, color = "#175eeb"}) => {
	return (
		<div
			style={{
				display: "inline-block",
				padding: "4px 12px",
				borderRadius: "9999px",
				backgroundColor: "white",
				color,
				minWidth: "fit-content",
				fontWeight: "bold",
				fontSize: "14px",
				textTransform: "uppercase",
			}}
		>
			<Translate>{label}</Translate>
		</div>
	)
}

export default Badge
